import type {StarredResource} from '../../../types/types.ts';
import {Store} from '../../lib/store.ts';

export class ResourceStar extends HTMLElement {
	async connectedCallback() {
		this.innerText = '☆';
		this.style.cursor = 'pointer';
		const store = await Store.load();
		const data = {
			id: this.getAttribute('id'),
			type: this.getAttribute('type'),
			label: this.getAttribute('label'),
			path: this.getAttribute('path')
		} as StarredResource;

		const render = (isStarred: boolean) => {
			if (isStarred) {
				this.innerText = '★';
				this.classList.add('starred');
			} else {
				this.classList.remove('starred');
				this.innerText = '☆';
			}
		};

		render(store.hasStarredResource(data.id));

		this.addEventListener('click', () => {
			if (store.hasStarredResource(data.id)) {
				store.removeStar(data.id);
				render(false);
			} else {
				store.addStarredResource(data);
				render(true);
			}
			this.dispatchEvent(
				new CustomEvent('star:change', {
					bubbles: true,
					detail: {
						data
					}
				})
			);
		});
	}
}

export function render(data: StarredResource) {
	return `<resource-star id="${data.id}" type="${data.type}" label="${data.label}" path="${data.path}"></resource-star>`;
}
